module.exports = __webpack_public_path__ + "img/tutor2.633b5a8d.png";